import { render, staticRenderFns } from "./cp_businessSlide.vue?vue&type=template&id=b479b59e&scoped=true"
import script from "./cp_businessSlide.vue?vue&type=script&lang=js"
export * from "./cp_businessSlide.vue?vue&type=script&lang=js"
import style0 from "./cp_businessSlide.vue?vue&type=style&index=0&id=b479b59e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b479b59e",
  null
  
)

export default component.exports